import parse from 'html-react-parser';

export const SpeakerCard = ({ name, profile, picture, styleClass }) => {
  return (
    <div className={styleClass ? styleClass : 'col-lg-6 col-md-6'}>
      <div className="single-event-item">
        <div className="single-event-image">
          <a href="#">
            <img src={picture ? picture : 'img/event/2.jpg'} alt="" />
          </a>
        </div>
        <div className="single-event-text">
          <h3>{name && name}</h3>

          {profile && parse(profile)}
        </div>
      </div>
    </div>
  );
};
